var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('page', {
    attrs: {
      "title": "account"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.admin,
      expression: "loading.admin"
    }]
  }, [_c('AccountForm', {
    attrs: {
      "account": _vm.account,
      "afterSave": _vm.getAdmin
    }
  })], 1), _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "mini"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }